var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('organization-form',{attrs:{"loading":_vm.loading,"organizationData":_vm.organization,"formErrors":_vm.formErrors},on:{"organizationSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }